import React from "react";
import Link from "@amzn/awsui-components-react/polaris/link";
import type { LinkProps } from "@amzn/awsui-components-react/polaris/link";
import { useTelemetry } from "@amzn/xb-hooks";
import type { TelemetryData } from "./types";

type HardLinkProps = LinkProps & {
  telemetry?: TelemetryData;
};

/**
 * HardLink is a direct wrapper around the Cloudscape Link component. It maintains all the functionality/API of
 * the base Cloudscape Link component and performs standard browser navigation with full page reloads.
 *
 * @param {object} [telemetry] - Optional telemetry data for tracking link clicks with eventId and optional eventDetails
 *
 * @see {@link https://cloudscape.design/components/link/?tabId=api|AWS Cloudscape Link API}
 */
export const HardLink: React.FC<HardLinkProps> = ({ telemetry, ...props }) => {
  const { trackEvent } = useTelemetry();
  if (telemetry?.eventId) {
    trackEvent("click", telemetry.eventId, {
      data: { ...telemetry.eventDetails },
    });
  }
  return <Link {...props} />;
};
